<template>
    <ul>
        <li><router-link to="/erfgoed">Erfgoed</router-link></li>
        <li><router-link to="/basisrapportages">Basisrapportages</router-link></li>
        <li><router-link to="/overlast">Overlast</router-link></li>
        <li><router-link to="/projecten">Projecten</router-link></li>
        <li><router-link to="/impactondernemers">Impactondernemers</router-link></li>
        <li><router-link to="/hubs">Hubs</router-link></li>
        <li><router-link to="/deelmobiliteit">Deelmobiliteit</router-link></li>
        <li><router-link to="/verkeershinder">Verkeershinder</router-link></li>
        <li><router-link to="/singelroute">Singelroute</router-link></li>
        <li><router-link to="/moreelse-route">Moreelse route</router-link></li>
        <li><router-link to="/vredenburgroute">Vredenburgroute</router-link></li>
        <li><router-link to="/veeartsenijroute">Veeartsenijroute</router-link></li>
    </ul>
</template>

<script>
export default {
    name: 'LinksPage',
}
</script>
